import {forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useRef, useState} from "react";
import {Button, Input, message, Modal} from "antd";
import {useTranslation} from "react-i18next";
import {generateUUID2, isStringNullOrEmpty} from "@/utils";
import {allFolder, updateFolder} from "@model/folder";
import {TFolder} from "@/index";
import {postcss} from "autoprefixer";
import {EVENT_UPDATE_FOLDER_NAME, POST_MESSAGE_REFRESH_FOLDER_LIST} from "@/Const";
import {postMessage} from "@/common/event";
import {IconClose} from "@/Icon";

let mFolderInfo:TFolder;
const DialogNewFolder = forwardRef((props:{onOkEvent:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialogEvent:onShowDialogEvent
    }));
    const {t} = useTranslation();
    const inputFolderRef = useRef<any>(null);
    const [folderName,setFolderName] = useState('');
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [btnOkName,setBtnOkName] = useState(t("Create"));

    const onShowDialogEvent = (folderInfo:TFolder)=>{
        mFolderInfo = folderInfo;
        setIsShowDialog(true);
        if (folderInfo != undefined){
            setFolderName(folderInfo.name);
            setBtnOkName(t("Modify"))
        }else{
            setFolderName('');
            setBtnOkName(t("Create"));
        }
    }

    /**
     * 保存文件夹
     */
    const onSaveFolderEvent = async ()=>{
        if(!isStringNullOrEmpty(folderName)){
            let arrayFolders = await allFolder();
            var arrayTmp = arrayFolders.filter(p=>p.name === folderName);
            if (arrayTmp.length >0){
                var item0 = arrayTmp[0];
                if (item0.id != mFolderInfo?.id){
                    message.error(t("Folder name exist"));
                    return;
                }
            }

            var newFolder:TFolder = {createTime: 0, id: "", name: ""};
            var isNewFolder = false;
            if(mFolderInfo != undefined){
                newFolder = {
                    ...mFolderInfo,
                    name:folderName
                }
            }else{
                isNewFolder = true;
                newFolder.id = generateUUID2();
                newFolder.name = folderName;
                newFolder.createTime = new Date().getTime();
                newFolder.sort = 0;
            }
            updateFolder(newFolder).then(res=>{
                setIsShowDialog(false);
                if(isNewFolder){
                    message.info(t("Folder created"));
                }else{
                    message.info(t("Folder updated"))
                }

                postMessage(POST_MESSAGE_REFRESH_FOLDER_LIST)
                postMessage(EVENT_UPDATE_FOLDER_NAME,newFolder);
                if (props.onOkEvent != undefined){
                    props.onOkEvent();
                }
            });
        }else{
            message.error('Input folder name');
        }
    }

    const onAfterOpenChange = ()=>{
        inputFolderRef?.current?.focus();
    }

    return(
        <Modal centered={true} afterOpenChange={onAfterOpenChange} onCancel={()=>setIsShowDialog(false)} visible={isShowDialog} footer={''} closable={true} closeIcon={<IconClose/>} width={'320px'}>
            <div style={{display:'flex',flexDirection:'column', alignItems:'center'}}>
                <h4 style={{display:'flex',width:'100%'}}>{t("New Folder")}</h4>
                <Input variant={'borderless'} className={'input-border'} ref={inputFolderRef} value={folderName} onChange={(e)=>setFolderName(e.currentTarget.value)} style={{marginTop:'16px'}} placeholder={t("New Folder")}/>
                <Button className='button-solid-style' onClick={onSaveFolderEvent} style={{marginTop:'26px',width:'100%',height:'36px',marginBottom:'-16px'}} type={"primary"}>{btnOkName}</Button>
            </div>
        </Modal>
    )
});

export default DialogNewFolder;